import React from 'react';
import { Dropdown, Menu } from 'antd';
import Button from './Button';
import { CalenderIconDark } from '../../assets';

const DateRangeFilter = ({ onDateChange }) => {
    const [selectedRange, setSelectedRange] = React.useState('Select Range');

    const handleQuickSelect = (rangeKey) => {
        let rangeText = '';
        let rangeValue = '';

        switch (rangeKey) {
            // case '1month':
            //     rangeText = 'Past 1 Month Active Users';
            //     rangeValue = 'M';
            //     break;
            case '6months':
                rangeText = 'Past 6 Months Active Users';
                rangeValue = 'L6';
                break;
            case '1year':
                rangeText = 'Past 1 Year Active Users';
                rangeValue = 'Y';
                break;
            default:
                rangeText = 'Select Range';
                rangeValue = '';
        }

        setSelectedRange(rangeText);
        onDateChange(rangeValue);
    };

    const menu = (
        <Menu>
            {/* <Menu.Item key="1month" onClick={() => handleQuickSelect('1month')}>
                Past 1 Month Active Users
            </Menu.Item> */}
            <Menu.Item key="6months" onClick={() => handleQuickSelect('6months')}>
                Past 6 Months Active Users
            </Menu.Item>
            <Menu.Item key="1year" onClick={() => handleQuickSelect('1year')}>
                Past 1 Year Active Users
            </Menu.Item>
        </Menu>
    );

    return (
        <div className="flex items-center gap-2">
            <Dropdown overlay={menu} trigger={['click']}>
                <Button
                    buttonProps={{ type: 'primary-square' }}
                    text={selectedRange}
                    buttonIcon={CalenderIconDark}
                />
            </Dropdown>
        </div>
    );
};

export default React.memo(DateRangeFilter);